<template>
  <div class="fixed-booking-summary mx-auto">
    <div class="container">
      <div class="sticky-section">
        <div ref="collapsible-section" class="collapsible-section">
          <div class="flex items-center justify-between pb-2">
            <p class="title">{{ $t("shared.booking_summary") }}</p>
            <v-icon @click.stop="toogleExpansionPanel(false)">close</v-icon>
          </div>
          <hr  class="mb-2"/>
          <nights-step-details-summary :flightDetails="flight" :finalPrice="priceWithDiscount" :extraNoPromoPercentage="extraNoPromoPercentage" :totalPassengers="totalPassengers" :itinerary="itinerary">
            <!-- <v-btn
              rounded
              light
              elevation="0"
              color="secondary"
              block
              class="avm-btn mx-auto"
              :loading="loading"
              @click="goToStep(showHotelbedsStep ? 'alojamiento' : 'extras')"
            >
              {{ $t("shared.continue") }}
            </v-btn> -->
          </nights-step-details-summary>
        </div>

        <div v-if="!collapsible.isOpen" class="flex justify-between items-center">
          <div class="flex flex-col items-start justify-center">
            <p v-if="onStepDetails" class="v-card__price color-black m-0 font-black">{{ totalPrice | currency_no_decimals }} </p>
            <p v-else-if="priceWithDiscount > 0" class="v-card__price color-black m-0 font-black"> {{ priceWithDiscount | currency_no_decimals }}</p>
            <p v-else class="v-card__price color-black m-0 font-black"> {{ $t('shared.free') }}</p>
            <v-btn class="show-more-btn text-base mt-1" text :ripple="false" height="auto" color="secondary"
              @click.stop="toogleExpansionPanel(false)">
              {{ collapsible.isOpen ? $t('shared.hide_details') : $t('shared.show_details') }}
            </v-btn>
          </div>
          <v-btn v-if="!$route.path.includes('datos-personales') && !$route.path.includes('pago') && flight.definitive" rounded color="secondary" class="avm-btn mt-0 font-black"
            :class="{ 'text-small': nextButtonText === $t('wizard_more_days.continue_without_a_hotel') }" elevation="0"
            :loading="$store.state.nights.loading || $store.state.stepper.loading" @click.stop="next">
            {{ nextButtonText }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { gsap, Cubic } from "gsap";
import moment from 'moment';
import {
  NIGHTS_GET_TOTAL_PRICE,
  NIGHTS_GET_PASSENGERS_COUNT,
  GET_NIGHTS_DISCOUNT,
  GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT,
  NIGHTS_GET_QUERY_PARAMS,
  NIGHTS_GET_NIGHTS,
  NIGHTS_GET_IS_PACK_FLIGHT,
  NIGHTS_GET_ITINERARY,
  GET_EXTRA_NO_PROMO_PRICE,
} from '../../../store/nights/getter-types';
import { mapGetters } from 'vuex';
import { goToStep } from '../mixins';
import { NIGHTS_SET_STATE } from '../../../store/nights/mutation-types';
import NightsStepDetailsSummary from '../../../../../resources/js/pages/nights/details/components/NightsStepDetailsSummary.vue';

export default {
  mixins: [goToStep],
  components: {
    NightsStepDetailsSummary
  },
  data() {
    return {
      collapsible: {
        isOpen: false,
        label: this.$t('shared.show_details'),
        tl: null,
      },
      showHotelbedsStep: window.show_hotelbeds,
    };
  },
  computed: {
    ...mapGetters({
      totalPrice: NIGHTS_GET_TOTAL_PRICE,
      priceWithDiscount: GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT,
      discount: GET_NIGHTS_DISCOUNT,
      passengersCount: NIGHTS_GET_PASSENGERS_COUNT,
      start: NIGHTS_GET_QUERY_PARAMS,
      end: NIGHTS_GET_QUERY_PARAMS,
      totalNights: NIGHTS_GET_NIGHTS,
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
      extraNoPromoPercentage: GET_EXTRA_NO_PROMO_PRICE
    }),
    itinerary() {
      return this.$route.query.itinerary;
    },
    extras() {
      return this.$store.state.nights.extras;
    },
    flightIsSet() {
      return !_.isEmpty(this.$store.state.nights.flight);
    },
    onStepDetails() {
      return this.$route.params.step === 'detalles';
    },
    flight() {
      return this.$store.state.nights.flight;
    },
    totalPassengers() {
      return this.$store.state.nights.passengers.length;
    },
    rooms() {
      const rooms = this.$store.state.nights.rooms;
      return `${rooms} ${rooms === 1 ? 'habitación' : 'habitaciones'}`;
    },
    showHotelDetails() {
      const aHotelIsSelected = !_.isEmpty(this.$store.state.nights.hotel);
      return aHotelIsSelected && ['extras', 'datos-personales'].includes(this.$route.params.step);
    },
    hotel() {
      return this.$store.state.nights.hotel;
    },
    summaryGoingItems() {
      if (!this.flightIsSet) return [];
      return [
        {
          icon: "/img/icons/airplane.svg",
          label: `${this.$store.state.nights.flight.cityFrom + ' (' + this.$store.state.nights.flight.routes[0].flyFrom + ')'} --> ${this.$store.state.nights.flight.cityTo + ' (' + this.$store.state.nights.flight.routes[0].flyTo + ')'}`,
        },
        {
          icon: "/img/icons/calendar.svg",
          label: this.parseDate(this.$store.state.nights.start)
        },
      ];
    },
    summaryReturnItems() {
      if (!this.flightIsSet) return [];
      return [
        {
          icon: "/img/icons/airplane.svg",
          label: `${this.$store.state.nights.flight.cityTo + ' (' + this.$store.state.nights.flight.routes[1].flyFrom + ')'} --> ${this.$store.state.nights.flight.cityFrom + ' (' + this.$store.state.nights.flight.routes[1].flyTo + ')'}`,
        },
        {
          icon: "/img/icons/calendar.svg",
          label: this.parseDate(this.$store.state.nights.end)
        },
      ];
    },
    nextButtonText() {
      if (this.isPackFlight) {
        return this.$t('shared.continue');
      }
      return this.$t('wizard_more_days.continue_without_a_hotel');
    },
    sixtyPercent() {
      return this.calculatePercentage(60).toFixed(2);
    },
    fortyPercent() {
      return this.calculatePercentage(40).toFixed(2);
    },
    dateRange() {
      const startDate = moment(this.start);
      const endDate = moment(this.end);
      const days = endDate.diff(startDate, 'days');
      const startDateFormatted = startDate.format('DD/MM/YYYY');
      const endDateFormatted = endDate.format('DD/MM/YYYY');
      return `${startDateFormatted} - ${endDateFormatted} (${days} días)`;
    },
  },
  mounted() {
    this.initExpansionPanel();
  },
  methods: {
    next() {
      if (this.$route.path.includes('alojamiento')) {
        this.$store.commit(NIGHTS_SET_STATE, ['hotel', {}]);
      }
      this.$emit('next');
    },
    initExpansionPanel() {
      const summaryTl = gsap.timeline({
        paused: true,
        reversed: true
      });
      gsap.timeline().set(".collapsible-section", {
        height: 0,
        autoAlpha: 0,
        display: "none"
      });
      let height = 500;
      const maxHeight = window.innerHeight - 98;
      if (height > maxHeight) {
        height = maxHeight;
      }
      summaryTl.to(".collapsible-section", 1, {
        delay: 0,
        height,
        autoAlpha: 1,
        display: "block",
        ease: Cubic.easeInOut
      });
      this.collapsible.tl = summaryTl;
    },
    toogleExpansionPanel(fromRouteChange) {
      if (fromRouteChange && !this.collapsible.isOpen) {
        return;
      }
      this.collapsible.isOpen = !this.collapsible.isOpen;
      this.$eventHub.$emit("update-overlay", this.collapsible.isOpen);
      this.collapsible.tl.reversed()
        ? this.collapsible.tl.play()
        : this.collapsible.tl.reverse();
      setTimeout(() => {
        this.collapsible.label = this.collapsible.isOpen
          ? this.$t('shared.hide_details')
          : this.$t('shared.show_details');
      }, 800);
    },
    name(type) {
      const { name } = this.$store.state.nights[type];
      return `${name}`;
    },
    parseDate(date) {
      if (!date) return '';
      const momentDate = moment(date);
      return momentDate.format('DD/MM/YYYY');
    },
    calculatePercentage(percentage) {
      const total = this.totalPrice;
      const result = (percentage / 100) * total;
      return result;
    },
    formatDate(date) {
      const startDate = moment(date);
      const endDate = moment(date);
      const startMonth = startDate.format('MMMM');
      const endMonth = endDate.format('MMMM');

      if (startMonth === endMonth) {
        return `${startDate.format('DD')} - ${endDate.format('DD')} ${startMonth} ${startDate.format('YYYY')}`;
      } else {
        return `${startDate.format('DD')} ${startMonth} - ${endDate.format('DD')} ${endMonth} ${startDate.format('YYYY')}`;
      }
    },
    submitStep() {
      this.$store.dispatch(SET_STEPPER_LOADING, true);
      this.$emit("submit-step");
    },
  },
  created() {
    window.Events.$on('route-will-change', () => this.toogleExpansionPanel(true));
  }
}
</script>

<style scoped lang="scss">
.fixed-booking-summary {
  overflow: visible;

  .collapsible-section .summary-body {
    padding: 0.5rem 0.2rem;
  }
}

.collapsible-section {
  background-color: white !important;
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  margin-bottom: 0 !important;
  padding: 1rem;
  overflow: auto;
}

.avm-btn.text-small {
  font-size: 17px;
}

.summary-title {
  font-size: 18px;
  font-weight: bold;
}

.span-title {
  font-size: 13px;
  font-weight: bold;
}

.span-detail {
  font-size: 13px;
  font-weight: normal
}

.total-detail {
  font-size: 22px;
  font-weight: bold;
}

.edit-btn {
  border-radius: 10px;
  border: solid 1px #979797;
  width: 90px;
  margin-top: 5px;
  font-weight: bold;
}
</style>
